import { Outlet, useParams } from 'react-router-dom'

import { AtsMessageTemplatePageDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { isPersonal } from 'modules/ats/lib/utils/messageTemplates'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import { BodySectionForm } from './BodySectionForm'
import { NameSectionForm } from './NameSectionForm'
import { VisibilitySectionForm } from './VisibilitySectionForm'

const AtsMessageTemplatePage = () => {
  const params = useParams()
  const messageTemplateId = Number(params.messageTemplateId)

  const { data, loading } = useQuery(AtsMessageTemplatePageDocument, {
    variables: { id: messageTemplateId },
  })

  const messageTemplate = data?.ats.messageTemplate
  const canManageCompanyMessageTemplates =
    data?.ats._policies.messageTemplatesManageCompanyMessageTemplates.can || false

  const canEditMessageTemplate =
    (messageTemplate && isPersonal(messageTemplate.visibility)) || canManageCompanyMessageTemplates

  return (
    <>
      <ResponsivePage.Body loading={loading || !messageTemplate} error={null} showHeader={false}>
        {messageTemplate && (
          <>
            <NameSectionForm messageTemplate={messageTemplate} canEdit={canEditMessageTemplate} />
            <VisibilitySectionForm
              messageTemplate={messageTemplate}
              canEdit={canManageCompanyMessageTemplates}
            />
            <BodySectionForm messageTemplate={messageTemplate} canEdit={canEditMessageTemplate} />
          </>
        )}
      </ResponsivePage.Body>
      <Outlet />
    </>
  )
}

export default AtsMessageTemplatePage
